import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-parentapp-header',
  templateUrl: './parentapp-header.component.html',
  styleUrls: ['./parentapp-header.component.scss']
})
export class ParentappHeaderComponent implements OnInit {
  ngOnInit(): void {

  }
  constructor(private router: Router) { }
  logout() {
    localStorage.clear();
    this.router.navigate(['parent/login'])
  }
}
